import React from 'react';

// Catches render crashes in a tab so a bug shows its error instead of a blank page.
// `resetKey` changes (e.g. the user switches tab) → the boundary clears itself.
export default class TabErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, resetKey: props.resetKey }; }
  static getDerivedStateFromError(error) { return { error }; }
  static getDerivedStateFromProps(props, state) {
    return props.resetKey !== state.resetKey ? { error: null, resetKey: props.resetKey } : null;
  }
  componentDidCatch(error, info) { console.error(`[${this.props.name || 'Tab'} crashed]`, error, info && info.componentStack); }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div role="alert" style={{ margin: '48px auto', maxWidth: 640, padding: 24, border: '1px solid var(--danger, #c0392b)', borderRadius: 12, background: 'var(--bg)' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--danger, #c0392b)', marginBottom: 8 }}>Something went wrong — reload</div>
        <div style={{ fontSize: 13, color: 'var(--text)', marginBottom: 10 }}>{this.props.name ? `${this.props.name}: ` : ''}{String(error && error.message || error)}</div>
        <pre style={{ fontSize: 11, color: 'var(--text-dim)', whiteSpace: 'pre-wrap', maxHeight: 160, overflow: 'auto', margin: '0 0 14px' }}>{String(error && error.stack || '').slice(0, 600)}</pre>
        <button onClick={() => window.location.reload()} style={{ padding: '7px 16px', border: 'none', borderRadius: 8, background: 'var(--accent)', color: '#fff', font: '600 13px "DM Sans", sans-serif', cursor: 'pointer' }}>Reload</button>
      </div>
    );
  }
}
